import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type GenderSelectInput_query$key } from '@/__generated__/GenderSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SelectOption,
  type SingleSelectInputProps,
  type SingleSelectInputRef
} from '@/components'

export type GenderSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: GenderSelectInput_query$key | null | undefined
}

export const GenderSelectInput = forwardRef<SingleSelectInputRef, GenderSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment GenderSelectInput_query on Query {
          genders(orderBy: [SEQUENCE_ASC]) {
            nodes {
              isOther
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.genders?.nodes, (gender) => ({
              isOther: gender!.isOther,
              label: gender!.name,
              value: gender!.rowId
            })),
          [queryData?.genders?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

GenderSelectInput.displayName = 'GenderSelectInput'
